/**
 * Date-extensions locale German (Austria) [de-at]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('de-at', {
    monthNames: ['Jänner','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    monthShortNames: ['Jän.','Febr.','Mrz.','Apr.','Mai','Jun.','Jul.','Aug.','Sept.','Okt.','Nov.','Dez.'],
    dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    dayShortNames: ['So.','Mo.','Di.','Mi.','Do.','Fr.','Sa.']
});
